import { useMemo } from 'react';

import type { ForecastDataPoint } from 'src/types/domain/ForecastDataPoint';

export function useForecastChart(
  data: ForecastDataPoint[],
  isNovelty: boolean = false,
) {
  return useMemo(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    const currentMonthIndex = data.findIndex(
      (point) => point.year === currentYear && point.month === currentMonth,
    );

    let filteredData = data;
    if (isNovelty) {
      let historyEndIndex = currentMonthIndex;

      if (historyEndIndex === -1) {
        historyEndIndex = data.findIndex((point) => !point.isHistory);
        if (historyEndIndex === -1) {
          historyEndIndex = data.length;
        }
      }

      if (historyEndIndex > 0) {
        const historyStartIndex = Math.max(0, historyEndIndex - 12);
        const historyData = data.slice(historyStartIndex, historyEndIndex);

        const forecastEndIndex = Math.min(data.length, historyEndIndex + 24);
        const forecastData = data.slice(historyEndIndex, forecastEndIndex);

        filteredData = [...historyData, ...forecastData];
      } else if (historyEndIndex === 0) {
        filteredData = data.slice(0, Math.min(data.length, 24));
      }
    }

    const processedData = filteredData.map((point) => {
      const isCurrentMonth =
        point.year === currentYear && point.month === currentMonth;

      if (point.isHistory && !isCurrentMonth) {
        return {
          ...point,
          forecastProposal: undefined,
          modelProposal: undefined,
          modelProposal2: undefined,
        };
      }

      return point;
    });

    const currentMonthPoint = processedData.find(
      (point) => point.year === currentYear && point.month === currentMonth,
    );
    const currentMonthId = currentMonthPoint?.month_id;

    const chartKey = `chart-${processedData.length}`;

    return { chartData: processedData, currentMonthId, chartKey };
  }, [data, isNovelty]);
}
